export enum XferType {
  XFER,
  XFER_REQUEST,
  XFER_CANCEL,
  XFER_EXPIRE,
  XFER_ACCEPT,
  XFER_REJECT,
  XFER_STEAL,
  XFER_STEAL_PENDING,
  XFER_STEAL_REJECT,
  XFER_AUTO_MIGRATION,
}

export namespace XferType {
  let elements = [
    XferType.XFER,
    XferType.XFER_REQUEST,
    XferType.XFER_CANCEL,
    XferType.XFER_EXPIRE,
    XferType.XFER_ACCEPT,
    XferType.XFER_REJECT,
    XferType.XFER_STEAL,
    XferType.XFER_STEAL_PENDING,
    XferType.XFER_STEAL_REJECT,
    XferType.XFER_AUTO_MIGRATION,
  ];
  let alias = "com.bcdfx.model.XferType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
